<template>
</template>
<script>
export default {
  name: 'Footer',
  data() {
    return {}
  },
  mounted: function() {}
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// shared/layout/Footer.vue